/**
 * @function isBoolean
 * @description Validates passed value is an boolean
 * @param {any} [value]
 * @returns boolean
 */

export function isBoolean(value) {
  return typeof value === 'boolean' && value !== null && value !== undefined;
}

/**
 * @function isNil
 * @description Validates passed value is an nil value
 * @param {any} [value]
 * @returns boolean
 */

export function isNil(value) {
  return value === null || value === undefined;
}

/**
 * @function isEmptyValue
 * @description Validates passed value is empty
 * @param {any} [value]
 * @returns boolean
 */

export function isEmptyValue(value) {
  if (Array.isArray(value)) {
    return value.length === 0 || isNil(value);
  }

  // Null is defined as object in JS, check object type and if not null
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0 || isNil(value);
  }

  // If all above conditions fail, check empty string is passed in value
  return isNil(value) || value === '';
}
